export enum Platform {
  EVM = "evm",
  APTOS = "aptos",
}

export enum Token {
  USDC = "0xbae207659db88bea0cbead6da0ed00aac12edcdda169e591cd41c94180b46f3b",
  USDT = "0x357b0b74bc833e95a115ad22604854d6b0fca151cecd94111770e5d6ffc9dc2b",
}

export enum PoolPlatforms {
  // aptos
  HYPERION = "hyperion",
  THALA = "thala",
  ARIES = "aries",
  TAPP_EXCHANGE = "tappexchange",
  MOAR = 'moar',

  // evm
  COLEND = "colend",
  WASABI = "wasabi",
  ALL_BRIDGE = "allBridge",
}
